import { Box } from '@mui/material';
import { useEffect } from 'react';
import { DataStatus } from '@/shared/lib';
import { useAppDispatch, useAppSelector } from '@/shared/model';
import { Loader } from '@/shared/ui';
import {
  initMeta,
  selectMetaIsLoaded,
  selectMetaStatus,
} from '../../model/slice';
import type { DataConfig } from '../../model/types';
import { DataGrid } from '../DataGrid/DataGrid';

interface Props {
  preset: unknown;
  isReadonly?: boolean;
  onReorderDimensions?: (info: {
    id: string;
    oldIndex: number;
    newIndex: number;
  }) => void;
  onColumnsWidthChange?: (columnName: string, newWidth?: number) => void;
}

export function CohortScannerWidget({
  preset,
  isReadonly = false,
  onReorderDimensions = () => {},
  onColumnsWidthChange = () => {},
}: Readonly<Props>) {
  const dispatch = useAppDispatch();
  const metaIsLoaded = useAppSelector(selectMetaIsLoaded);
  const metaStatus = useAppSelector(selectMetaStatus);
  const metaIsLoading = metaStatus === DataStatus.loading;

  useEffect(() => {
    dispatch(initMeta());
  }, [dispatch]);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
      }}
    >
      <Loader active={metaIsLoading} />
      {metaIsLoaded && (
        <DataGrid
          isReadonly={isReadonly}
          config={preset as DataConfig}
          onReorderDimensions={onReorderDimensions}
          onColumnsWidthChange={onColumnsWidthChange}
        />
      )}
    </Box>
  );
}
